export const MONEY_VALIDATION_MESSAGES = {
  INVALID_AMOUNT: 'Please enter a valid amount',
  MUST_BE_WHOLE_NUMBER: "Decimals aren't allowed. Please round up or down to a whole number",
} as const;
